module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide",
      "appear": ""
    }
  }, [(_vm.dataRequiredLoaded) ? _c('div', {
    staticClass: "app-content-body fade-in-up content-transition"
  }, [_c('div', {
    staticClass: "hbox hbox-auto-xs hbox-auto-sm"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "r"
  }, [(_vm.isGrvEmLeilao && _vm.data.ultimoLeilao) ? _c('titulo-secao', {
    staticClass: "bg-warning text-black"
  }, [_c('strong', {
    staticClass: "text-danger"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v(" Atenção")]), _c('br'), _vm._v("\n            Esta GRV está vinculada ao leilão\n            "), (_vm.ACL.check('restrito_visitante', _vm.currentUser.id) && _vm.ACL.check('visualizar_leilao', _vm.currentUser.id)) ? _c('span', [_c('router-link', {
    staticClass: "hidden-print",
    staticStyle: {
      "clear": "left",
      "color": "black"
    },
    attrs: {
      "to": {
        name: 'leiloes.visualizar',
        params: {
          id: _vm.data.ultimoLeilao.id
        }
      }
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.data.ultimoLeilao.titulo))])])], 1) : _c('span', [_c('strong', [_vm._v(_vm._s(_vm.data.ultimoLeilao.titulo))])])]) : _vm._e(), _vm._v(" "), (_vm.isGgv) ? _c('titulo-secao', {
    staticClass: "bg-warning text-black"
  }, [_c('strong', [_vm._v("GGV")]), _c('br'), _vm._v("\n            Você está fazendo a vistoria para guarda deste veículo\n          ")]) : _c('div', {
    staticClass: "bg-light lter b-b wrapper-md"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-xs-12"
  }, [_c('h1', {
    staticClass: "font-thin h3"
  }, [_vm._v("\n                  GRV\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('router-link', {
    staticClass: "pull-right hidden-print",
    staticStyle: {
      "clear": "left"
    },
    attrs: {
      "to": {
        name: 'roubo-furto.list',
        query: {
          grv: _vm.data.numero
        }
      }
    }
  }, [_c('strong', {
    staticClass: "label no-radius bg-info"
  }, [_vm._v("Voltar")])])], 1)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('div', [_c('form', {
    staticClass: "bs-example form-horizontal form-grv",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit($event)
      }
    }
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [(_vm.cadastroError !== null) ? _c('div', {
    ref: "error",
    staticClass: "alert alert-danger",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "m-b-sm font-bold"
  }, [_vm._v("Erro ao registrar a GRV, corrija e tente novamente")]), _vm._v(" "), _vm._l((_vm.cadastroError), function(erro, key) {
    return _c('p', [_vm._v(_vm._s(_vm.printError(erro)))])
  })], 2) : _vm._e(), _vm._v(" "), _c('a', {
    ref: "sucessMsg",
    attrs: {
      "name": "sucessMsg",
      "id": "sucessMsg",
      "href": "javascript:void(0)"
    }
  }), _vm._v(" "), (_vm.atualizadoSucesso !== null) ? _c('div', {
    ref: "error",
    staticClass: "alert alert-success",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "font-bold"
  }, [_vm._v("Atualizado com sucesso!")])]) : _vm._e(), _vm._v(" "), (_vm.data.id) ? _c('div', {
    staticClass: "col-sm-12 col-xs-12 m-b"
  }, [_c('h1', {
    staticClass: "font-thin h3"
  }, [(_vm.ACL.check('restrito_visitante', _vm.currentUser.id) && _vm.podeAdicionarAtendimento) ? _c('button', {
    staticClass: "btn btn-default btn-md m-l-xs pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openCadastroAtendimento
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Cadastrar Atendimento\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.ACL.check('restrito_visitante', _vm.currentUser.id)) ? _c('button', {
    staticClass: "btn btn-default btn-md m-l-xs pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openCadastroTelegrama
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Cadastrar Notificação Telegrama\n                        ")]) : _vm._e(), _vm._v(" "), _c('btn-menu-pericia', {
    staticClass: "m-l-xs pull-right",
    attrs: {
      "grv": JSON.parse(JSON.stringify(_vm.data))
    },
    on: {
      "openFormPericia": _vm.openFormPericia,
      "reload": _vm.start
    }
  }), _vm._v(" "), (_vm.podeAlterarStatus) ? _c('btn-altera-status-grv', {
    staticClass: "pull-right m-t-none",
    staticStyle: {
      "margin-top": "-10px !important"
    },
    attrs: {
      "lista-status": _vm.listaStatusPossiveisParaAlteracao
    },
    on: {
      "statusAlterado": _vm.start
    }
  }) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "grv"
    }
  }, [_vm._v("GRV")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.numero),
      expression: "data.numero"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "id": "grv",
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.data.numero)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "numero", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.ACL.check('restrito_visitante', _vm.currentUser.id)) ? _c('button', {
    staticClass: "btn btn-danger btn-md m-t-sm",
    attrs: {
      "type": "button",
      "disabled": _vm.edit
    },
    on: {
      "click": _vm.gerarNumeroGrvPoliciaCivil
    }
  }, [_vm._v("\n                          Gerar número da GRV\n                        ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataApreensao"
    }
  }, [_vm._v("Data da apreensão")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.extraModel.dataApreensao),
      expression: "extraModel.dataApreensao"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('##/##/####'),
      expression: "'##/##/####'"
    }],
    ref: "dataApreensao",
    staticClass: "form-control",
    attrs: {
      "id": "dataApreensao",
      "placeholder": "dd/mm/yyyy",
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.extraModel.dataApreensao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.extraModel, "dataApreensao", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "horaApreensao"
    }
  }, [_vm._v("Hora da apreensão")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.extraModel.horaApreensao),
      expression: "extraModel.horaApreensao"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('##:##'),
      expression: "'##:##'"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "horaApreensao",
      "placeholder": "00:00",
      "type": "time",
      "required": "",
      "disabled": "",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.extraModel.horaApreensao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.extraModel, "horaApreensao", $event.target.value)
      }
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("Pátio")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.patio),
      expression: "data.patio"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "patio",
      "disabled": !_vm.podeEditarCampoPatio,
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.data, "patio", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.dataRequired.patios), function(patio) {
    return _c('option', {
      key: patio.id,
      domProps: {
        "value": patio.id
      }
    }, [_vm._v("\n                                " + _vm._s(patio.nome) + "\n                              ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Contrato")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.contrato),
      expression: "data.contrato"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "contrato",
      "disabled": _vm.data.status !== 0 && _vm.edit,
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.data, "contrato", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.listCategoriasBem]
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.dataRequired.contratos), function(contrato) {
    return _c('option', {
      key: contrato.id,
      domProps: {
        "value": contrato.id
      }
    }, [_vm._v(_vm._s(contrato.nome) + "\n                                  ")])
  })], 2)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2"
  }), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("Delito")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.delito),
      expression: "data.delito"
    }, {
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.delito)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "delito", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "dataSolicitacaoReboque"
    }
  }, [_vm._v("Data/Hora Solicitação do Reboque")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('##/##/#### ##:##'),
      expression: "'##/##/#### ##:##'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.data.dataSolicitacaoReboque),
      expression: "data.dataSolicitacaoReboque"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "dataSolicitacaoReboque",
      "type": "text",
      "placeholder": "dd/mm/yyyy hh:mm"
    },
    domProps: {
      "value": (_vm.data.dataSolicitacaoReboque)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "dataSolicitacaoReboque", $event.target.value)
      }
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2"
  }), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("Formulário Operadora")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.formularioOperadora),
      expression: "data.formularioOperadora"
    }, {
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.formularioOperadora)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "formularioOperadora", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "dataPrevisaoChegada"
    }
  }, [_vm._v("Data/Hora Previsão de Chegada")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('##/##/#### ##:##'),
      expression: "'##/##/#### ##:##'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.data.dataPrevisaoChegada),
      expression: "data.dataPrevisaoChegada"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "dataPrevisaoChegada",
      "type": "text",
      "placeholder": "dd/mm/yyyy hh:mm"
    },
    domProps: {
      "value": (_vm.data.dataPrevisaoChegada)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "dataPrevisaoChegada", $event.target.value)
      }
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2"
  }), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("Formulário Pátio")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.formularioPatio),
      expression: "data.formularioPatio"
    }, {
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.formularioPatio)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "formularioPatio", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "dataChegadaRemocao"
    }
  }, [_vm._v("Data/Hora Chegada Remoção")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('##/##/#### ##:##'),
      expression: "'##/##/#### ##:##'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.data.dataChegadaRemocao),
      expression: "data.dataChegadaRemocao"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "dataChegadaRemocao",
      "type": "text",
      "placeholder": "dd/mm/yyyy hh:mm"
    },
    domProps: {
      "value": (_vm.data.dataChegadaRemocao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "dataChegadaRemocao", $event.target.value)
      }
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dpOrigem"
    }
  }, [_vm._v("DP Origem")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.dpOrigem),
      expression: "data.dpOrigem"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "dpOrigem",
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.dpOrigem)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "dpOrigem", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "dataSaidaRemocao"
    }
  }, [_vm._v("Data/Hora Saída Remoção")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('##/##/#### ##:##'),
      expression: "'##/##/#### ##:##'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.data.dataSaidaRemocao),
      expression: "data.dataSaidaRemocao"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "dataSaidaRemocao",
      "type": "text",
      "placeholder": "dd/mm/yyyy hh:mm"
    },
    domProps: {
      "value": (_vm.data.dataSaidaRemocao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "dataSaidaRemocao", $event.target.value)
      }
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "roOrigem"
    }
  }, [_vm._v("RO Origem")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.roOrigem),
      expression: "data.roOrigem"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "roOrigem",
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.roOrigem)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "roOrigem", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "dataEntradaPatio"
    }
  }, [_vm._v("Data/Hora Entrada no Pátio")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('##/##/#### ##:##'),
      expression: "'##/##/#### ##:##'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.data.dataEntradaPatio),
      expression: "data.dataEntradaPatio"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "dataEntradaPatio",
      "type": "text",
      "placeholder": "dd/mm/yyyy hh:mm"
    },
    domProps: {
      "value": (_vm.data.dataEntradaPatio)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "dataEntradaPatio", $event.target.value)
      }
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataRoOrigem"
    }
  }, [_vm._v("Data RO Origem")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('##/##/#### ##:##'),
      expression: "'##/##/#### ##:##'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.data.dataRoOrigem),
      expression: "data.dataRoOrigem"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "dataRoOrigem",
      "type": "text",
      "placeholder": "dd/mm/yyyy hh:mm"
    },
    domProps: {
      "value": (_vm.data.dataRoOrigem)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "dataRoOrigem", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "roApreensaoRecuperacao"
    }
  }, [_vm._v("RO Apreensão/Recuperação")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.roApreensaoRecuperacao),
      expression: "data.roApreensaoRecuperacao"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "roApreensaoRecuperacao",
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.roApreensaoRecuperacao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "roApreensaoRecuperacao", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "tipoRemocao"
    }
  }, [_vm._v("Tipo de remoção")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.tipoRemocao),
      expression: "data.tipoRemocao"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "tipoRemocao"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.data, "tipoRemocao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("Rodando")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("Rebocado")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "situacaoApreensao"
    }
  }, [_vm._v("Situação de Apreensão")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.situacaoApreensao),
      expression: "data.situacaoApreensao"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "situacaoApreensao"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.data, "situacaoApreensao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.situacoesApreensao), function(situacao) {
    return _c('option', {
      domProps: {
        "value": situacao.id
      }
    }, [_vm._v(_vm._s(situacao.nome))])
  })], 2)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-offset-2 col-sm-10"
  }, [_c('label', {
    staticClass: "i-checks m-b-none",
    attrs: {
      "for": "liberarJudicial"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.liberarPorDecisaoJudicial),
      expression: "data.liberarPorDecisaoJudicial"
    }],
    attrs: {
      "type": "checkbox",
      "id": "liberarJudicial",
      "tabindex": "0",
      "aria-checked": "false",
      "aria-invalid": "false"
    },
    domProps: {
      "checked": Array.isArray(_vm.data.liberarPorDecisaoJudicial) ? _vm._i(_vm.data.liberarPorDecisaoJudicial, null) > -1 : (_vm.data.liberarPorDecisaoJudicial)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.data.liberarPorDecisaoJudicial,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.data, "liberarPorDecisaoJudicial", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.data, "liberarPorDecisaoJudicial", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.data, "liberarPorDecisaoJudicial", $$c)
        }
      }
    }
  }), _c('i')]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "liberarJudicial"
    }
  }, [_vm._v("Liberar para Retirada por Decisão Judicial")])])])])]), _vm._v(" "), (_vm.data.tipoRemocao === 1) ? _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('hr'), _vm._v(" "), _c('h4', [_vm._v("Dados do Apresentante")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "nomeApresentante"
    }
  }, [_vm._v("Nome")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.nomeApresentante),
      expression: "data.nomeApresentante"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "nomeApresentante",
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.data.nomeApresentante)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "nomeApresentante", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "telefoneApresentante"
    }
  }, [_vm._v("Telefone")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.telefoneApresentante),
      expression: "data.telefoneApresentante"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "telefoneApresentante",
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.data.telefoneApresentante)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "telefoneApresentante", $event.target.value)
      }
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "cepRemocao"
    }
  }, [_vm._v("Documento (RG ou CPF)")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.documentoApresentante),
      expression: "data.documentoApresentante"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "documentoApresentante",
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.documentoApresentante)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "documentoApresentante", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "cepRemocao"
    }
  }, [_vm._v("CEP")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.cepApresentante),
      expression: "data.cepApresentante"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('##.###-###'),
      expression: "'##.###-###'"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "cepApresentante",
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.cepApresentante)
    },
    on: {
      "keyup": function($event) {
        return _vm.pesquisarCep(_vm.data.cepApresentante, 'Apresentante')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "cepApresentante", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "enderecoApresentante"
    }
  }, [_vm._v("Endereço")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.enderecoApresentante),
      expression: "data.enderecoApresentante"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "enderecoApresentante",
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.data.enderecoApresentante)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "enderecoApresentante", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "bairroApresentante"
    }
  }, [_vm._v("Bairro")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.bairroApresentante),
      expression: "data.bairroApresentante"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "bairroApresentante",
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.data.bairroApresentante)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "bairroApresentante", $event.target.value)
      }
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "complementoApresentante"
    }
  }, [_vm._v("Complemento")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.complementoApresentante),
      expression: "data.complementoApresentante"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "complementoApresentante",
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.complementoApresentante)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "complementoApresentante", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "ufApresentante"
    }
  }, [_vm._v("UF")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.ufApresentante),
      expression: "data.ufApresentante"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "ufApresentante",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.data, "ufApresentante", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "selected": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.estadosBr), function(estado) {
    return _c('option', {
      key: estado.sigla,
      domProps: {
        "value": estado.sigla
      }
    }, [_vm._v(_vm._s(estado.nome))])
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "cidadeApresentante"
    }
  }, [_vm._v("Cidade")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.cidadeApresentante),
      expression: "data.cidadeApresentante"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "cidadeApresentante",
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.data.cidadeApresentante)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "cidadeApresentante", $event.target.value)
      }
    }
  })])])])])])])])]) : _vm._e(), _vm._v(" "), _c('titulo-secao', [_vm._v("Local de Apreensão / Remoção")]), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "cepApreensao"
    }
  }, [_vm._v("CEP Apreensão")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.cepApreensao),
      expression: "data.cepApreensao"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('##.###-###'),
      expression: "'##.###-###'"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "cepApreensao",
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.cepApreensao)
    },
    on: {
      "keyup": function($event) {
        return _vm.pesquisarCep(_vm.data.cepApreensao, 'Apreensao')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "cepApreensao", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "enderecoApreensao"
    }
  }, [_vm._v("Endereço Apreensão")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.enderecoApreensao),
      expression: "data.enderecoApreensao"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "enderecoApreensao",
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.enderecoApreensao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "enderecoApreensao", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "bairroApreensao"
    }
  }, [_vm._v("Bairro Apreensão")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.bairroApreensao),
      expression: "data.bairroApreensao"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "bairroApreensao",
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.bairroApreensao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "bairroApreensao", $event.target.value)
      }
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "complementoApreensao"
    }
  }, [_vm._v("Complemento Apreensão")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.complementoApreensao),
      expression: "data.complementoApreensao"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "complementoApreensao",
      "type": "text",
      "disabled": !_vm.podeEditarCampoComplementoApreensao
    },
    domProps: {
      "value": (_vm.data.complementoApreensao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "complementoApreensao", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "ufApreensao"
    }
  }, [_vm._v("UF Apreensão")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.ufApreensao),
      expression: "data.ufApreensao"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "ufApreensao"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.data, "ufApreensao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "selected": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ES"
    }
  }, [_vm._v("Espírito Santo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RJ"
    }
  }, [_vm._v("Rio de Janeiro")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "cidadeApreensao"
    }
  }, [_vm._v("Cidade Apreensão")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.cidadeApreensao),
      expression: "data.cidadeApreensao"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "cidadeApreensao",
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.cidadeApreensao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "cidadeApreensao", $event.target.value)
      }
    }
  })])])])])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "cepRemocao"
    }
  }, [_vm._v("CEP Remoção")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.cepRemocao),
      expression: "data.cepRemocao"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('##.###-###'),
      expression: "'##.###-###'"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "cepRemocao",
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.cepRemocao)
    },
    on: {
      "keyup": function($event) {
        return _vm.pesquisarCep(_vm.data.cepRemocao, 'Remocao')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "cepRemocao", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('button', {
    staticClass: "btn btn-info btn-sm m-l-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.copiarEnderecoApreensao
    }
  }, [_c('i', {
    staticClass: "fa fa-clone"
  }), _vm._v(" Copiar dados de endereço de apreensão\n                            ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "enderecoRemocao"
    }
  }, [_vm._v("Endereço Remoção")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.enderecoRemocao),
      expression: "data.enderecoRemocao"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "enderecoRemocao",
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.data.enderecoRemocao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "enderecoRemocao", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "bairroRemocao"
    }
  }, [_vm._v("Bairro Remoção")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.bairroRemocao),
      expression: "data.bairroRemocao"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "bairroRemocao",
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.data.bairroRemocao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "bairroRemocao", $event.target.value)
      }
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "complementoRemocao"
    }
  }, [_vm._v("Complemento Remoção")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.complementoRemocao),
      expression: "data.complementoRemocao"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "complementoRemocao",
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.complementoRemocao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "complementoRemocao", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "ufRemocao"
    }
  }, [_vm._v("UF Remoção")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.ufRemocao),
      expression: "data.ufRemocao"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "ufRemocao",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.data, "ufRemocao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "selected": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ES"
    }
  }, [_vm._v("Espírito Santo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RJ"
    }
  }, [_vm._v("Rio de Janeiro")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "cidadeRemocao"
    }
  }, [_vm._v("Cidade Remoção")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.cidadeRemocao),
      expression: "data.cidadeRemocao"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "cidadeRemocao",
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.data.cidadeRemocao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "cidadeRemocao", $event.target.value)
      }
    }
  })])])])])])])])]), _vm._v(" "), _c('titulo-secao', [_vm._v("Dados do Veículo")]), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-offset-2 col-sm-10"
  }, [_c('label', {
    staticClass: "i-checks m-b-none",
    attrs: {
      "for": "comRodas"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.comRodas),
      expression: "data.comRodas"
    }],
    attrs: {
      "type": "checkbox",
      "id": "comRodas",
      "tabindex": "0",
      "aria-checked": "false",
      "aria-invalid": "false"
    },
    domProps: {
      "checked": Array.isArray(_vm.data.comRodas) ? _vm._i(_vm.data.comRodas, null) > -1 : (_vm.data.comRodas)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.data.comRodas,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.data, "comRodas", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.data, "comRodas", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.data, "comRodas", $$c)
        }
      }
    }
  }), _c('i')]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "comRodas"
    }
  }, [_vm._v("Com Rodas")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-offset-2 col-sm-10"
  }, [_c('label', {
    staticClass: "i-checks m-b-none",
    attrs: {
      "for": "semPlaca"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.semPlaca),
      expression: "data.semPlaca"
    }],
    attrs: {
      "type": "checkbox",
      "id": "semPlaca",
      "tabindex": "0",
      "aria-checked": "false",
      "aria-invalid": "false"
    },
    domProps: {
      "checked": Array.isArray(_vm.data.semPlaca) ? _vm._i(_vm.data.semPlaca, null) > -1 : (_vm.data.semPlaca)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.data.semPlaca,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.data, "semPlaca", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.data, "semPlaca", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.data, "semPlaca", $$c)
        }
      }
    }
  }), _c('i')]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "semPlaca"
    }
  }, [_vm._v("Sem Placa")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-offset-2 col-sm-10"
  }, [_c('label', {
    staticClass: "i-checks m-b-none",
    attrs: {
      "for": "possuiPlacaOriginal"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.possuiPlacaOriginal),
      expression: "data.possuiPlacaOriginal"
    }],
    attrs: {
      "type": "checkbox",
      "id": "possuiPlacaOriginal",
      "tabindex": "0",
      "aria-checked": "false",
      "aria-invalid": "false"
    },
    domProps: {
      "checked": Array.isArray(_vm.data.possuiPlacaOriginal) ? _vm._i(_vm.data.possuiPlacaOriginal, null) > -1 : (_vm.data.possuiPlacaOriginal)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.data.possuiPlacaOriginal,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.data, "possuiPlacaOriginal", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.data, "possuiPlacaOriginal", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.data, "possuiPlacaOriginal", $$c)
        }
      }
    }
  }), _c('i')]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "possuiPlacaOriginal"
    }
  }, [_vm._v("Placa Original")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-offset-2 col-sm-10"
  }, [_c('label', {
    staticClass: "i-checks m-b-none",
    attrs: {
      "for": "naoEmplacado"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.naoEmplacado),
      expression: "data.naoEmplacado"
    }],
    attrs: {
      "type": "checkbox",
      "id": "naoEmplacado",
      "tabindex": "0",
      "aria-checked": "false",
      "aria-invalid": "false"
    },
    domProps: {
      "checked": Array.isArray(_vm.data.naoEmplacado) ? _vm._i(_vm.data.naoEmplacado, null) > -1 : (_vm.data.naoEmplacado)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.data.naoEmplacado,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.data, "naoEmplacado", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.data, "naoEmplacado", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.data, "naoEmplacado", $$c)
        }
      }
    }
  }), _c('i')]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "naoEmplacado"
    }
  }, [_vm._v("Não Emplacado")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-offset-2 col-sm-10"
  }, [_c('label', {
    staticClass: "i-checks m-b-none",
    attrs: {
      "for": "sucata"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.sucata),
      expression: "data.sucata"
    }],
    attrs: {
      "type": "checkbox",
      "id": "sucata",
      "tabindex": "0",
      "aria-checked": "false",
      "aria-invalid": "false"
    },
    domProps: {
      "checked": Array.isArray(_vm.data.sucata) ? _vm._i(_vm.data.sucata, null) > -1 : (_vm.data.sucata)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.data.sucata,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.data, "sucata", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.data, "sucata", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.data, "sucata", $$c)
        }
      }
    }
  }), _c('i')]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "sucata"
    }
  }, [_vm._v("Sucata")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "placa"
    }
  }, [_vm._v("Placa Ostentada")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.placa),
      expression: "data.placa"
    }],
    ref: "placaOstentada",
    staticClass: "form-control",
    attrs: {
      "id": "placa",
      "type": "text",
      "disabled": !_vm.podeEditarCamposVeiculo
    },
    domProps: {
      "value": (_vm.data.placa)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "placa", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), (_vm.data.periciaRealizada) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "placaAlterada"
    }
  }, [_vm._v("Placa Alterada")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.placaAlterada),
      expression: "data.placaAlterada"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "placaAlterada",
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.data.placaAlterada)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "placaAlterada", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('##/##/#### ##:##'),
      expression: "'##/##/#### ##:##'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.data.dataPlacaAlterada),
      expression: "data.dataPlacaAlterada"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "dataEntregaDevolucao",
      "type": "text",
      "placeholder": "dd/mm/yyyy hh:mm",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.data.dataPlacaAlterada)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "dataPlacaAlterada", $event.target.value)
      }
    }
  })])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "placaOriginal"
    }
  }, [_vm._v("Placa Original")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.placaOriginal),
      expression: "data.placaOriginal"
    }],
    ref: "placaOriginal",
    staticClass: "form-control",
    attrs: {
      "id": "placaOriginal",
      "type": "text",
      "disabled": !_vm.podeEditarCamposVeiculo
    },
    domProps: {
      "value": (_vm.data.placaOriginal)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "placaOriginal", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('button', {
    staticClass: "btn btn-info btn-sm m-l-xs btn-colsultaGrv",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.consultaPlacaChassi(_vm.data.placaOriginal, 'placa')
      }
    }
  }, [_vm._v("Consultar")]), _vm._v(" "), ([22799, 5].some(function (n) { return _vm.currentUser.id === n; }) && _vm.cacheConsultaPlaca) ? _c('button', {
    staticClass: "btn btn-info btn-sm m-l-xs btn-colsultaGrv",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.consultaPlacaChassi(_vm.data.placaOriginal, 'placa', true)
      }
    }
  }, [_vm._v("\n                            Ver resultado consulta\n                          ")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "chassi"
    }
  }, [_vm._v("Chassi")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.chassi),
      expression: "data.chassi"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "chassi",
      "type": "text",
      "disabled": !_vm.podeEditarCamposVeiculo,
      "required": !_vm.data.sucata
    },
    domProps: {
      "value": (_vm.data.chassi)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "chassi", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('button', {
    staticClass: "btn btn-info btn-sm m-l-xs btn-colsultaGrv",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.consultaPlacaChassi(_vm.data.chassi, 'chassi')
      }
    }
  }, [_vm._v("Consultar")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "numeroMotor"
    }
  }, [_vm._v("Número do motor")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.numeroMotor),
      expression: "data.numeroMotor"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "numeroMotor",
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.numeroMotor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "numeroMotor", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Categoria")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.bemCategoria),
      expression: "data.bemCategoria"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "categoria"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.data, "bemCategoria", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.atualizaEquipamentoCategoria]
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.dataRequired.categoriaBem), function(categoriaBem) {
    return _c('option', {
      key: categoriaBem.id,
      domProps: {
        "value": categoriaBem.id
      }
    }, [_vm._v(_vm._s(categoriaBem.nome) + "\n                                ")])
  })], 2)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "marca"
    }
  }, [_vm._v("Marca/Modelo")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.marca),
      expression: "data.marca"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "marca",
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.data.marca)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "marca", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "modelo"
    }
  }, [_vm._v("Tipo")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.modelo),
      expression: "data.modelo"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "modelo",
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.data.modelo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "modelo", $event.target.value)
      }
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "cor"
    }
  }, [_vm._v("Cor")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.cor),
      expression: "data.cor"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "cor",
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.data.cor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "cor", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "vaga"
    }
  }, [_vm._v("Vaga")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.vaga),
      expression: "data.vaga"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "vaga",
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.vaga)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "vaga", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "ano"
    }
  }, [_vm._v("Ano")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.ano),
      expression: "data.ano"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "ano",
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.ano)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "ano", $event.target.value)
      }
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "localizacaoAtual"
    }
  }, [_vm._v("Localização Atual")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.localizacaoAtual),
      expression: "data.localizacaoAtual"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "localizacaoAtual",
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.localizacaoAtual)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "localizacaoAtual", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "veiculoComChave"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-10"
  }, [_c('label', {
    staticClass: "i-checks m-b-none",
    attrs: {
      "for": "veiculoComChave"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.comChave),
      expression: "data.comChave"
    }],
    attrs: {
      "type": "checkbox",
      "id": "veiculoComChave",
      "tabindex": "0",
      "aria-checked": "false",
      "aria-invalid": "false"
    },
    domProps: {
      "checked": Array.isArray(_vm.data.comChave) ? _vm._i(_vm.data.comChave, null) > -1 : (_vm.data.comChave)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.data.comChave,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.data, "comChave", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.data, "comChave", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.data, "comChave", $$c)
        }
      }
    }
  }), _c('i')]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "veiculoComChave"
    }
  }, [_vm._v("Veículo possui chaves")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "numeroChave"
    }
  }, [_vm._v("Número da chave")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.numeroChave),
      expression: "data.numeroChave"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "numeroChave",
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.numeroChave)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "numeroChave", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    attrs: {
      "for": "renavam"
    }
  }, [_vm._v("Renavam")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.renavam),
      expression: "data.renavam"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "renavam",
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.renavam)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "renavam", $event.target.value)
      }
    }
  })])])])])])])]), _vm._v(" "), _c('titulo-secao', [_vm._v("Policial")]), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "policialFiltro"
    }
  }, [_vm._v("Filtrar Lista de Policiais")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtroPoliciaisList),
      expression: "filtroPoliciaisList"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Filtrar por matrícula ou nome",
      "id": "policialFiltro"
    },
    domProps: {
      "value": (_vm.filtroPoliciaisList)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filtroPoliciaisList = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("Selecionar Policial")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.policialApreensao),
      expression: "data.policialApreensao"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "policial",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.data, "policialApreensao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.setPolicialSelecionado($event, _vm.data.policialApreensao)
      }]
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.filteredPoliciaisList), function(policial) {
    return _c('option', {
      key: policial.id,
      domProps: {
        "value": policial.id
      }
    }, [_vm._v("\n                            " + _vm._s(policial.nome) + "\n                          ")])
  })], 2)])]), _vm._v(" "), (_vm.policialSelecionado) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "nomeAgenteApreensor"
    }
  }, [_vm._v("Nome")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.policialSelecionado.nome),
      expression: "policialSelecionado.nome"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "nomeAgenteApreensor",
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.policialSelecionado.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.policialSelecionado, "nome", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "matriculaAgenteApreensor"
    }
  }, [_vm._v("Matrícula")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.policialSelecionado.matricula),
      expression: "policialSelecionado.matricula"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "matriculaAgenteApreensor",
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.policialSelecionado.matricula)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.policialSelecionado, "matricula", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "patente"
    }
  }, [_vm._v("Patente")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.patentePolicialApreensao),
      expression: "data.patentePolicialApreensao"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "",
      "id": "patente"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.data, "patentePolicialApreensao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.patentes), function(patente) {
    return _c('option', {
      key: patente.id,
      domProps: {
        "value": patente.id
      }
    }, [_vm._v(_vm._s(patente.nome))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "unidadePolicial"
    }
  }, [_vm._v("Unidade Policial")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.unidadePolicialApreensao),
      expression: "data.unidadePolicialApreensao"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "unidadePolicial"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.data, "unidadePolicialApreensao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.unidadesPoliciais), function(unidadePolicial) {
    return _c('option', {
      key: unidadePolicial.id,
      domProps: {
        "value": unidadePolicial.id
      }
    }, [_vm._v("\n                            " + _vm._s(unidadePolicial.nome) + "\n                          ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "observacoes"
    }
  }, [_vm._v("Observações Veículo")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.observacoes),
      expression: "data.observacoes"
    }],
    staticClass: "form-control",
    staticStyle: {
      "resize": "none"
    },
    attrs: {
      "id": "observacoes",
      "rows": "7"
    },
    domProps: {
      "value": (_vm.data.observacoes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "observacoes", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('titulo-secao', [_vm._v("Dados do Reboque")]), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "reboquista"
    }
  }, [_vm._v("Empresa de Reboque")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empresaSelecionada),
      expression: "empresaSelecionada"
    }],
    staticClass: "form-control w-auto w-full-xs",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.empresaSelecionada = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.carregaReboqueReboquista]
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("selecione")]), _vm._v(" "), _vm._l((_vm.empresas), function(empresa) {
    return _c('option', {
      domProps: {
        "value": empresa.id
      }
    }, [_vm._v("\n                            " + _vm._s(empresa.nome) + " (" + _vm._s(_vm._f("formataCnpj")(empresa.cnpj)) + ")\n                          ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "reboquista"
    }
  }, [_vm._v("Reboquista")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.reboquista),
      expression: "data.reboquista"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "reboquista",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.data, "reboquista", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.dataRequired.reboquistas), function(reboquista) {
    return _c('option', {
      key: reboquista.id,
      attrs: {
        "disabled": !reboquista.ativo
      },
      domProps: {
        "value": reboquista.id
      }
    }, [_vm._v("\n                            " + _vm._s(reboquista.nome) + " (#" + _vm._s(reboquista.codigo) + ") "), (!reboquista.ativo) ? _c('span', {
      staticStyle: {
        "font-size": "small",
        "color": "red"
      }
    }, [_vm._v("(inativo)")]) : _vm._e()])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "reboque"
    }
  }, [_vm._v("Reboque")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.reboque),
      expression: "data.reboque"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "reboque",
      "required": "",
      "disabled": !_vm.empresaSelecionada
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.data, "reboque", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.dataRequired.reboques), function(reboque) {
    return _c('option', {
      key: reboque.id,
      attrs: {
        "disabled": !reboque.ativo || reboque.deleted
      },
      domProps: {
        "value": reboque.id
      }
    }, [_vm._v("\n                            " + _vm._s(reboque.placa) + " "), (!reboque.ativo) ? _c('span', {
      staticStyle: {
        "font-size": "small",
        "color": "red"
      }
    }, [_vm._v("(inativo)")]) : _vm._e()])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "kmInicial"
    }
  }, [_vm._v("KM inicial")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.kmInicialDoReboque),
      expression: "data.kmInicialDoReboque"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "kmInicial",
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.kmInicialDoReboque)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "kmInicialDoReboque", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "col-sm-offset-2 col-sm-10"
  }, [_vm._v("KM inicial do reboque ao atender o acionamento.")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "kmFinal"
    }
  }, [_vm._v("KM final")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.kmFinalDoReboque),
      expression: "data.kmFinalDoReboque"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "kmFinal",
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.kmFinalDoReboque)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "kmFinalDoReboque", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "col-sm-offset-2 col-sm-8"
  }, [_vm._v("KM final do reboque ao atender o acionamento.")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "observacoesReboque"
    }
  }, [_vm._v("Observações")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.observacoesReboque),
      expression: "data.observacoesReboque"
    }],
    staticClass: "form-control",
    staticStyle: {
      "resize": "none"
    },
    attrs: {
      "id": "observacoesReboque",
      "rows": "7"
    },
    domProps: {
      "value": (_vm.data.observacoesReboque)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "observacoesReboque", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('titulo-secao', [_vm._v("Equipamentos / Acessórios")]), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [(!_vm.dataRequired.equipamentos.length) ? _c('div') : _vm._l((_vm.dataRequired.equipamentos), function(equip) {
    return _c('div', {
      key: equip.id,
      staticClass: "form-group b-b padder-v"
    }, [_c('div', {
      staticClass: "col-sm-offset-2 col-sm-10"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-4"
    }, [_c('label', {
      staticClass: "i-checks m-b-none"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (equip.checked),
        expression: "equip.checked"
      }],
      attrs: {
        "type": "checkbox",
        "id": equip.id,
        "tabindex": "0",
        "aria-checked": "false",
        "aria-invalid": "false"
      },
      domProps: {
        "checked": Array.isArray(equip.checked) ? _vm._i(equip.checked, null) > -1 : (equip.checked)
      },
      on: {
        "change": [function($event) {
          var $$a = equip.checked,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(equip, "checked", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(equip, "checked", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(equip, "checked", $$c)
          }
        }, function($event) {
          return _vm.marcaEquipamento($event, equip)
        }]
      }
    }), _c('i')]), _vm._v(" "), _c('label', {
      attrs: {
        "for": equip.id
      }
    }, [_vm._v(_vm._s(equip.nome))])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (equip.checked),
        expression: "equip.checked"
      }],
      staticClass: "col-xs-4 form-inline"
    }, [_c('label', [_vm._v("Avaria: ")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (equip.avaria),
        expression: "equip.avaria"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(equip, "avaria", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "disabled": "",
        "selected": ""
      },
      domProps: {
        "value": null
      }
    }, [_vm._v("Nenhum")]), _vm._v(" "), _vm._l((_vm.avarias), function(avaria) {
      return _c('option', {
        key: avaria.id,
        domProps: {
          "value": avaria.id
        }
      }, [_vm._v(_vm._s(avaria.nome))])
    })], 2)]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (false),
        expression: "false"
      }],
      staticClass: "col-xs-4"
    }, [_c('btn-check-possui', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (equip.checked),
        expression: "equip.checked"
      }],
      model: {
        value: (equip.possui),
        callback: function($$v) {
          _vm.$set(equip, "possui", $$v)
        },
        expression: "equip.possui"
      }
    })], 1)])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "volumesInteriorVeiculo"
    }
  }, [_vm._v("Volumes ou acessórios no\n                        interior do veículo")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.volumesInteriorVeiculo),
      expression: "data.volumesInteriorVeiculo"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "volumesInteriorVeiculo",
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.volumesInteriorVeiculo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "volumesInteriorVeiculo", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "observacoesEquipamentos"
    }
  }, [_vm._v("Observações")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.observacoesEquipamentos),
      expression: "data.observacoesEquipamentos"
    }],
    staticClass: "form-control",
    staticStyle: {
      "resize": "none"
    },
    attrs: {
      "id": "observacoesEquipamentos",
      "rows": "7"
    },
    domProps: {
      "value": (_vm.data.observacoesEquipamentos)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "observacoesEquipamentos", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-offset-2 col-sm-10"
  }, [_c('label', {
    staticClass: "i-checks m-b-none"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.comAssinaturaPolicial),
      expression: "data.comAssinaturaPolicial"
    }],
    attrs: {
      "type": "checkbox",
      "id": "comAssinaturaPolicial",
      "tabindex": "0",
      "aria-checked": "false",
      "aria-invalid": "false"
    },
    domProps: {
      "checked": Array.isArray(_vm.data.comAssinaturaPolicial) ? _vm._i(_vm.data.comAssinaturaPolicial, null) > -1 : (_vm.data.comAssinaturaPolicial)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.data.comAssinaturaPolicial,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.data, "comAssinaturaPolicial", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.data, "comAssinaturaPolicial", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.data, "comAssinaturaPolicial", $$c)
        }
      }
    }
  }), _c('i')]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "comAssinaturaPolicial"
    }
  }, [_vm._v("Com assinatura do policial")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-offset-2 col-sm-10"
  }, [_c('label', {
    staticClass: "i-checks m-b-none"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.comAssinaturaReboquista),
      expression: "data.comAssinaturaReboquista"
    }],
    attrs: {
      "type": "checkbox",
      "id": "comAssinaturaReboquista",
      "tabindex": "0",
      "aria-checked": "false",
      "aria-invalid": "false"
    },
    domProps: {
      "checked": Array.isArray(_vm.data.comAssinaturaReboquista) ? _vm._i(_vm.data.comAssinaturaReboquista, null) > -1 : (_vm.data.comAssinaturaReboquista)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.data.comAssinaturaReboquista,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.data, "comAssinaturaReboquista", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.data, "comAssinaturaReboquista", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.data, "comAssinaturaReboquista", $$c)
        }
      }
    }
  }), _c('i')]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "comAssinaturaReboquista"
    }
  }, [_vm._v("Com assinatura do reboquista")])])])], 2)]), _vm._v(" "), (_vm.isGgv) ? _c('div', {
    staticClass: "bg-light lter b-b wrapper-md"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-xs-12"
  }, [_c('h2', {
    staticClass: "font-thin h3"
  }, [_vm._v("\n                        Parecer Final\n                      ")])])])]) : _vm._e(), _vm._v(" "), (_vm.isGgv) ? _c('div', {
    staticClass: "wrapper-md m-b-lg"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Em conformidade com a GRV")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ggv.conforme),
      expression: "ggv.conforme"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.ggv, "conforme", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Conforme")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("Não conforme")])])])])]) : _vm._e(), _vm._v(" "), _c('titulo-secao', [_vm._v("Lacres")]), _vm._v(" "), _c('lacres-grv', {
    attrs: {
      "lacres": _vm.data.lacres
    }
  }), _vm._v(" "), _c('titulo-secao', [_vm._v("Localização")]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-hover table-bordered table-striped b-t b-light",
    staticStyle: {
      "border-top": "1px solid #eaeff0"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Data de alteração da localização")]), _vm._v(" "), _c('th', [_vm._v("Localização")]), _vm._v(" "), _c('th', [_vm._v("Operador de empilhadeira")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.data.historicoLocalizacao), function(local) {
    return _c('tr', [_c('td', {
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(_vm.moment(local.dataRegistro.date).format('L LTS')))]), _vm._v(" "), _c('td', {
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(local.localizacao && local.localizacao.nome || 'Não informado'))]), _vm._v(" "), _c('td', {
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(local.operadorEmpilhadeira && local.operadorEmpilhadeira.nome || 'Não informado'))])])
  }), 0)])]), _vm._v(" "), _c('titulo-secao', [_vm._v("Notificações de telegrama para este processo")]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-hover table-bordered table-striped b-t b-light",
    staticStyle: {
      "border-top": "1px solid #eaeff0"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', [_vm._v("Data da Postagem")]), _vm._v(" "), _c('th', [_vm._v("Data de recebimento da AR")]), _vm._v(" "), _c('th', [_vm._v("Situação")])])]), _vm._v(" "), _c('tbody', [(_vm.loadingNotificacoes) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("Carregando...")])]) : _vm._l((_vm.data.telegramas), function(telegrama) {
    return _c('tr', [_c('td', {
      attrs: {
        "scope": "row",
        "role": "button",
        "tabindex": "0"
      },
      on: {
        "click": function($event) {
          return _vm.openCadastroTelegrama(telegrama.id)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(telegrama.nome) + "\n                      ")]), _vm._v(" "), (telegrama.dataPostagem != null) ? _c('td', {
      attrs: {
        "scope": "row",
        "role": "button",
        "tabindex": "0"
      },
      on: {
        "click": function($event) {
          return _vm.openCadastroTelegrama(telegrama.id)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.formatarData(telegrama.dataPostagem)) + "\n                      ")]) : _c('td', {
      attrs: {
        "role": "button",
        "tabindex": "0"
      },
      on: {
        "click": function($event) {
          return _vm.openCadastroTelegrama(telegrama.id)
        }
      }
    }, [_c('i', [_vm._v("Não cadastrado")])]), _vm._v(" "), (telegrama.dataRetornoAr != null) ? _c('td', {
      attrs: {
        "scope": "row",
        "role": "button",
        "tabindex": "0"
      },
      on: {
        "click": function($event) {
          return _vm.openCadastroTelegrama(telegrama.id)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.formatarData(telegrama.dataRetornoAr)) + "\n                      ")]) : _c('td', {
      attrs: {
        "role": "button",
        "tabindex": "0"
      },
      on: {
        "click": function($event) {
          return _vm.openCadastroTelegrama(telegrama.id)
        }
      }
    }, [_c('i', [_vm._v("Não cadastrado")])]), _vm._v(" "), (telegrama.situacao != null) ? _c('td', {
      attrs: {
        "scope": "row",
        "role": "button",
        "tabindex": "0"
      },
      on: {
        "click": function($event) {
          return _vm.openCadastroTelegrama(telegrama.id)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(telegrama.situacao.nome) + "\n                      ")]) : _c('td', {
      attrs: {
        "role": "button",
        "tabindex": "0"
      },
      on: {
        "click": function($event) {
          return _vm.openCadastroTelegrama(telegrama.id)
        }
      }
    }, [_c('i', [_vm._v("Não cadastrado")])])])
  })], 2)])]), _vm._v(" "), (_vm.filteredArquivosTelegrama.length) ? _c('titulo-secao', [_vm._v("Arquivos de telegrama para este processo")]) : _vm._e(), _vm._v(" "), _c('lista-arquivos-notificacoes-grv', {
    attrs: {
      "loading": _vm.loadingNotificacoes,
      "lista": _vm.filteredArquivosTelegrama
    }
  }), _vm._v(" "), (_vm.ACL.check('restrito_visitante', _vm.currentUser.id)) ? _c('div', {
    staticClass: "wrapper-sm m-t-n m-b"
  }, [(_vm.isGrvRegistrada) ? _c('button', {
    staticClass: "btn btn-info btn-md m-l-xs btn-colsultaGrv",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openCadastroTelegrama($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Cadastrar Notificação de Telegrama\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.isGrvRegistrada) ? _c('button', {
    staticClass: "btn btn-info btn-md m-l-xs btn-colsultaGrv",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openMultipleInputFileTelegrama($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-upload"
  }), _vm._v(" Cadastrar Arquivo de Telegrama\n                  ")]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    ref: "uploadTelegrama",
    attrs: {
      "type": "file",
      "name": "files[]",
      "id": "fileInptImg",
      "accept": "application/pdf"
    },
    on: {
      "change": _vm.uploadDocumentoTelegrama
    }
  })]) : _vm._e(), _vm._v(" "), _c('titulo-secao', [_vm._v("Atendimentos para este processo")]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-hover table-bordered table-striped b-t b-light",
    staticStyle: {
      "border-top": "1px solid #eaeff0"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Data do Contato")]), _vm._v(" "), _c('th', [_vm._v("Origem")]), _vm._v(" "), _c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', [_vm._v("Fila de Atendimento")]), _vm._v(" "), _c('th', [_vm._v("Data/Hora Agendamento")]), _vm._v(" "), (_vm.ACL.check('excluir_atendimento_grv', _vm.currentUser.id)) ? _c('th', [_vm._v("Excluir")]) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.data.atendimentos), function(atendimento) {
    return _c('tr', [(atendimento.dataNotificacao) ? _c('td', {
      attrs: {
        "scope": "row",
        "role": "button",
        "tabindex": "0"
      },
      on: {
        "click": function($event) {
          return _vm.openCadastroAtendimento(atendimento.id)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.formatarData(atendimento.dataNotificacao, 'DD/MM/YYYY')) + "\n                      ")]) : _c('td', {
      attrs: {
        "role": "button",
        "tabindex": "0"
      },
      on: {
        "click": function($event) {
          return _vm.openCadastroAtendimento(atendimento.id)
        }
      }
    }, [_c('i', [_vm._v("Não informado")])]), _vm._v(" "), _c('td', {
      attrs: {
        "scope": "row",
        "role": "button",
        "tabindex": "0"
      },
      on: {
        "click": function($event) {
          return _vm.openCadastroAtendimento(atendimento.id)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.origem(atendimento.origem)) + "\n                      ")]), _vm._v(" "), _c('td', {
      attrs: {
        "scope": "row",
        "role": "button",
        "tabindex": "0"
      },
      on: {
        "click": function($event) {
          return _vm.openCadastroAtendimento(atendimento.id)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(atendimento.nome) + "\n                      ")]), _vm._v(" "), _c('td', {
      attrs: {
        "scope": "row",
        "role": "button",
        "tabindex": "0"
      },
      on: {
        "click": function($event) {
          return _vm.openCadastroAtendimento(atendimento.id)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.filaAtendimento(atendimento.filaAtendimento)) + "\n                      ")]), _vm._v(" "), (atendimento.dataAgendamento) ? _c('td', {
      attrs: {
        "scope": "row",
        "role": "button",
        "tabindex": "0"
      },
      on: {
        "click": function($event) {
          return _vm.openCadastroAtendimento(atendimento.id)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.formatarData(atendimento.dataAgendamento, 'DD/MM/YYYY HH:mm')) + "\n                      ")]) : _c('td', {
      attrs: {
        "role": "button",
        "tabindex": "0"
      },
      on: {
        "click": function($event) {
          return _vm.openCadastroAtendimento(atendimento.id)
        }
      }
    }, [_c('i', [_vm._v("Não informado")])]), _vm._v(" "), (_vm.ACL.check('excluir_atendimento_grv', _vm.currentUser.id)) ? _c('td', {
      attrs: {
        "scope": "row",
        "role": "button",
        "tabindex": "0"
      }
    }, [_c('button', {
      staticClass: "btn btn-danger btn-md m-l-xs btn-colsultaGrv",
      attrs: {
        "type": "button",
        "disabled": !_vm.isGrvRegistrada
      },
      on: {
        "click": function($event) {
          return _vm.deleteAtendimento(atendimento.id)
        }
      }
    }, [_vm._v("\n                          Excluir\n                        ")])]) : _vm._e()])
  }), 0)])]), _vm._v(" "), (_vm.filteredArquivosAtendimento.length) ? _c('titulo-secao', [_vm._v("Arquivos de atendimento para este processo")]) : _vm._e(), _vm._v(" "), _c('lista-arquivos-notificacoes-grv', {
    attrs: {
      "loading": _vm.loadingNotificacoes,
      "lista": _vm.filteredArquivosAtendimento
    }
  }), _vm._v(" "), (_vm.ACL.check('restrito_visitante', _vm.currentUser.id)) ? _c('div', {
    staticClass: "wrapper-sm m-t-n m-b"
  }, [(_vm.isGrvRegistrada && _vm.podeAdicionarAtendimento) ? _c('button', {
    staticClass: "btn btn-info btn-md m-l-xs btn-colsultaGrv",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openCadastroAtendimento($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Cadastrar Notificação de Atendimento\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.isGrvRegistrada && _vm.podeAdicionarAtendimento) ? _c('button', {
    staticClass: "btn btn-info btn-md m-l-xs btn-colsultaGrv",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openMultipleInputFileAtendimento($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-upload"
  }), _vm._v(" Cadastrar Arquivo de Atendimento\n                  ")]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    ref: "uploadAtendimento",
    attrs: {
      "type": "file",
      "name": "files[]",
      "id": "fileInptImg2",
      "accept": "application/pdf"
    },
    on: {
      "change": _vm.uploadDocumentoAtendimento
    }
  })]) : _vm._e(), _vm._v(" "), _c('titulo-secao', [_vm._v("Arquivos para GRVs")]), _vm._v(" "), _c('arquivos-grv', {
    attrs: {
      "arquivos": _vm.data.arquivos,
      "tipos-arquivo": _vm.dataRequired.tipoArquivo,
      "tipos-arquivo-ocultar": _vm.tiposArquivoOcultar
    }
  }), _vm._v(" "), (!_vm.isGgv) ? _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.ACL.check('restrito_visitante', _vm.currentUser.id)) ? _c('button', {
    staticClass: "btn btn-success btn-md m-l-xs btn-colsultaGrv"
  }, [_vm._v("Salvar")]) : _vm._e()])])]) : _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.ACL.check('restrito_visitante', _vm.currentUser.id)) ? _c('button', {
    staticClass: "btn btn-success btn-block btn-lg"
  }, [_vm._v("Confirmar GGV")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_vm._v("\n                        * a confirmação inclui imeditamente este bem no pátio e transmite as informações para o DETRO\n                      ")])])])])], 1)])])])])]), _vm._v(" "), (_vm.showFormPericia) ? _c('popup-viewer', {
    attrs: {
      "title": ((_vm.data.periciaRealizada ? 'Visualização' : 'Cadastro') + " de perícia para a GRV " + (_vm.data.numero))
    },
    on: {
      "close": _vm.closeFormPericia
    }
  }, [_c('pericia', {
    attrs: {
      "grvId": _vm.data.id,
      "periciaId": _vm.data.pericia && _vm.data.pericia.id
    },
    on: {
      "finishSubmit": _vm.closeFormPericia
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showFormPolicial) ? _c('popup-viewer', {
    attrs: {
      "title": "Cadastro de Policial"
    },
    on: {
      "close": _vm.closeFormPolicial
    }
  }, [_c('CadastroPolicial', {
    attrs: {
      "viewer-mode": ""
    },
    on: {
      "finishSubmit": _vm.closeFormPolicial
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showFormAtendimento) ? _c('popup-viewer', {
    attrs: {
      "title": ((_vm.atendimentoSelecionado ? 'Visualização' : 'Cadastro') + " de atendimento para a GRV " + (_vm.data.numero))
    },
    on: {
      "close": _vm.closeFormAtendimento
    }
  }, [_c('NovaCadastroNotificacaoAtendimento', {
    attrs: {
      "grv": _vm.data,
      "atendimentoId": _vm.atendimentoSelecionado
    },
    on: {
      "finishSubmit": _vm.closeFormAtendimento
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showFormTelegrama) ? _c('popup-viewer', {
    attrs: {
      "title": ((_vm.telegramaSelecionado ? 'Visualização' : 'Cadastro') + " de telegrama para a GRV " + (_vm.data.numero))
    },
    on: {
      "close": _vm.closeFormTelegrama
    }
  }, [_c('NovoCadastroNotificacaoTelegrama', {
    attrs: {
      "grv": _vm.data,
      "telegramaId": _vm.telegramaSelecionado
    },
    on: {
      "finishSubmit": _vm.closeFormTelegrama
    }
  })], 1) : _vm._e()], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59e01d6d","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/policia-civil/roubo-furto/components/Grv.vue
// module id = 1711
// module chunks = 17